module.exports = __webpack_public_path__ + "static/img/jifen.dc0f5801.png";